jQuery(document).ready(function($){
	  if ($('.product-description h5').length) {

	// This first section is all about formatting the content correctly for tabs
	
	// Add the opening list tag before the first H5 within the description 
	$('.description').prepend('<ul class="tabs" />');
	
	// Loop through each H5 in the description
	$('.description h5').not(":empty").each(function(index, value){
	    // Assign them each a number, in order
		var num = index + 1;
		
		// For each H5, wrap everything from after the heading to just before the next one in a div
		// Give each div a unique ID that includes those assigned numbers
	    $(this).nextUntil('h5').wrapAll('<div class="tab-content" id="tab' + num + '" />');
	    
	    // For each h5, wrap the H5 itself in a list item and an anchor link to the div
	    $(this).wrap('<li class="single-tab" data-index="' + index + '"><a href="#tab' + num + '"></a></li>');
	});
	
	// Wrap the whole list and the tab content divs in a surrounding div
	$('.description ul.tabs, .description .tab-content').wrapAll('<div class="tab-area" />');
	
	// Move that surrounding div after the form
	$('.description .tab-area').appendTo('.content');
	
	// Loop through the list items (the tab headers)
    var tabs = new Array();
	$('.description .single-tab').each(function(){
	    // Move them into the list element
      	var index = $(this).data('index');
      	tabs[index] = $(this);
		//$(this).appendTo('.description ul.tabs');
	});
  	jQuery.each( tabs, function(index, tab){
      tab.appendTo('.description ul.tabs');
  	});
  
	// The rest of this is the actual tab functionality, from http://www.jacklmoore.com/notes/jquery-tabs/
      }
});